import React from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../project-create/Urls';
import DataCard from '../profile-edit/DataCard';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function ProjectTitle(props) {
  const { project } = props;
  const { history } = usePageRouter();

  return (
    <DataCard
      title="Guiding or essential question"
      icon={DocumentTextIcon}
      subtitle={project.data.title || '(not provided)'}
      onClick={() => history.push(Urls(project).TITLE)}
    />
  );
};
